
import { Component, Vue } from "vue-property-decorator";
import historianTemp from "@/template/historian/historianTemp.vue";
@Component
export default class HistorianTemp extends historianTemp {
  mounted() {}
}
